import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merge Tailwind classes so a later class wins over an earlier one that sets
 * the same property. `cn("p-2", "p-4")` is `"p-4"`, not both.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
